import { ReactElement } from 'react'
import footerLogo from '../../assets/images/logo-without-shadow.svg'

const Footer = (): ReactElement => {
  return (
    <footer
      className='flex justify-between w-full'
    >
      <div className='flex items-center'>
        <img src={footerLogo} className='w-[156px] cursor-pointer' alt='DopaGE logo' />
        <span className='font-bold text-[38px] leading-[51.91px] text-dopage-lightGreen ml-[18.37px]'>Overdose Prevention Portal</span>
      </div>
    </footer>
  )
}

export default Footer
